import { action, observable, extendObservable } from "mobx";

import TbComFileDetail from "../detail/TbComFileDetail";

export default class TbComFileMapngDetail extends TbComFileDetail {
  @observable private dwldId?: string;
  @observable private sortOrdr?: number;

  public constructor(data?) {
    super(data);
  }

  public getDwldId() {
    return this.dwldId;
  }

  @action
  public setDwldId(dwldId: string) {
    this.dwldId = dwldId;
  }

  public getSortOrdr(){
    return this.sortOrdr;
  }

  @action
  public setSortOrdr(sortOrdr: number) {
    this.sortOrdr = sortOrdr;
  }
}
